'use strict';

var chunkC7C34JBA_js = require('./chunk-C7C34JBA.js');
var a = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var a__default = /*#__PURE__*/_interopDefault(a);

var y=({data:e,onClickHandler:i,lazyLoadImage:m})=>{let{title:s,data:t}=e||{};return a__default.default.createElement(a__default.default.Fragment,null,a__default.default.createElement(chunkC7C34JBA_js.f,null,s),a__default.default.createElement(chunkC7C34JBA_js.m,null,t.map(o=>a__default.default.createElement("li",{key:o.name},a__default.default.createElement("a",{onClick:()=>i(o.name),href:o.url},a__default.default.createElement("img",{loading:m?"lazy":"eager",src:o.image,alt:o.alt}),a__default.default.createElement(chunkC7C34JBA_js.n,null,o.name))))))};

exports.a = y;
